<div class="weather-dialog">
  <form [formGroup]="weatherForm">
    <mat-form-field>
      <mat-label>Zip Code</mat-label>
      <input type="number" matInput formControlName="zipCode" />
    </mat-form-field>
  </form>

  <mat-radio-group
    class="mat-fiord"
    aria-label="Select an option"
    [(ngModel)]="type"
  >
    <mat-radio-button value="F">°F</mat-radio-button>
    <mat-radio-button value="C">°C</mat-radio-button>
  </mat-radio-group>
  <div>
    <button mat-button [mat-dialog-close]>Cancel</button>
    <button
      mat-raised-button
      color="primary"
      [disabled]="saveDisabled"
      (click)="save()"
    >
      Save
    </button>
  </div>
</div>
